"use client"

import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useTERouter } from "@/hooks/app/useTERouter"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { thunks } from "@/lib/redux/thunks"
import SearchIcon from "@/components/icons/SearchIcon"
import { Button } from "antd"
import { useParams, useRouter } from "next/navigation"
import { useTranslation } from "react-i18next"
import { FC } from "react"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { track } from "@/lib/tracking"
import { toast } from "react-toastify"

type ButtonSearchProps = {
  /** Một hàng (trang chủ): nút vuông chỉ icon, khớp hotel search */
  compact?: boolean
}

const ButtonSearch: FC<ButtonSearchProps> = ({ compact = false }) => {
  const isDesktop = useIsDesktop()
  const tourCategory = useAppSelector(state => state.tour.formSearch.tourCategory)
  const departureDate = useAppSelector(state => state.tour.formSearch.departureDate)
  const router = useTERouter()
  const params = useParams()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const compactStyle = compact
    ? { height: '4.4rem', width: '4.4rem', minWidth: '4.4rem', padding: 0 }
    : { height: '6.835rem', maxHeight: 'unset', fontSize: '2.5rem', minWidth: '20rem' }

  return (
    <Button
      block={!isDesktop && !compact}
      type='primary'
      size='large'
      icon={<SearchIcon style={{ fontSize: compact ? '1.6rem' : '3rem' }} />}
      style={compactStyle}
      onClick={() => {
        if (!tourCategory?.id) {
          dispatch(tourActions.setDestinationSearchError(true))
          toast.dismiss()
          toast.error(t("tour.destination_required_inline"), { position: "top-right" })
          return;
        }
        dispatch(tourActions.setDestinationSearchError(false))
        if (tourCategory?.id === params.categoryId) {
          // DOP-925: tour_search — case cùng category, dispatch tại chỗ (điều hướng
          // sang category mới sẽ được track trong useToursByCategory)
          track('tour_search', {
            destination: tourCategory?.name || tourCategory?.id,
            category_id: tourCategory?.id,
            travel_date: departureDate || undefined,
          })
          dispatch(thunks.tours_search({
            params: {
              category_id: params?.categoryId,
              start_date: departureDate,
              search_mode: 1
            }
          }))
        }
        router.push(`/tours/category/${tourCategory?.id}?start_date=${departureDate || ""}`)
      }}
    >
      {compact ? null : isDesktop ? t("common.search_short") : t("common.search")}
    </Button>
  )
}

export default ButtonSearch